import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(termsAndConditionsSaga);

import { takeEvery } from 'redux-saga/effects';
import { termsAndConditionsRequestData } from '../../slices/termsAndConditions/termsAndConditions';
import { getCollectionWorker } from '../workers';

function termsAndConditionsSaga() {
  return _regeneratorRuntime.wrap(function termsAndConditionsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeEvery(termsAndConditionsRequestData, getCollectionWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

export default termsAndConditionsSaga;